import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Autorizacion } from '../_modules/permisos/models/autorizacion';

const API_URL = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})
export class AutorizacionPresencialService {

  constructor(private http: HttpClient) { }

  crearAutorizacion(alumno: any, fecha: string) {
    const model = {
      tipoOrigen: 301, // 301
      personaId: alumno.id,
      fechaInicio: fecha
      // fechaInicio: moment(fecha).format('YYYY-MM-DD')
    }
    return this.http.post(`${API_URL}/api/personas/autorizacion`, model);
  }

  eliminarAutorizacion(alumno: any) {
    return this.http.delete(`${API_URL}/api/personas/autorizacion/${alumno.id}/tipo/AutorizacionPresencial`);
  }
}
